/**
 * Horizontal curation gallery — scroll by one masonry panel.
 */
(function () {
  const NAV_SELECTOR = '[data-bbs-curation-nav]';

  function prefersReducedMotion() {
    return (
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  /**
   * @param {HTMLElement} wrap
   */
  function bindCurationNav(wrap) {
    const scroll = wrap.querySelector('[data-bbs-curation-scroll]');
    const prev = wrap.querySelector('[data-bbs-curation-prev]');
    const next = wrap.querySelector('[data-bbs-curation-next]');
    if (!(scroll instanceof HTMLElement)) return;

    const scrollByPanel = (/** @type {number} */ direction) => {
      const panel = scroll.querySelector('[data-bbs-curation-panel]');
      if (!(panel instanceof HTMLElement)) return;
      const styles = getComputedStyle(scroll);
      const gap = parseFloat(styles.columnGap || styles.gap || '16') || 16;
      const amount = panel.offsetWidth + gap;
      scroll.scrollBy({
        left: direction * amount,
        behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      });
    };

    if (prev instanceof HTMLButtonElement) {
      prev.addEventListener('click', () => scrollByPanel(-1));
    }
    if (next instanceof HTMLButtonElement) {
      next.addEventListener('click', () => scrollByPanel(1));
    }
  }

  function init() {
    document.querySelectorAll(NAV_SELECTOR).forEach((wrap) => {
      if (wrap instanceof HTMLElement) bindCurationNav(wrap);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
